import api from '../../../../api/client'

function normalizeOptionsPayload(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  return []
}

export async function listProjects(params) {
  const { data } = await api.get('/projects/', { params })
  return data
}

export async function exportProjectsCSV(params) {
  const { data } = await api.get('/projects/export', {
    params,
    responseType: 'blob',
  })
  return data
}

export async function getProjectStats() {
  const { data } = await api.get('/projects/stats')
  return data
}

export async function getProjectDetail(projectId) {
  const { data } = await api.get(`/projects/${projectId}`)
  return data
}

export async function getProjectDrilldown(projectId) {
  const { data } = await api.get(`/projects/${projectId}/drilldown`)
  return data
}

export async function listProjectDrilldownTasks(projectId, params = {}) {
  const { data } = await api.get('/tasks/', {
    params: {
      page: 1,
      page_size: 10,
      includeTotal: true,
      archive: false,
      project_id: projectId,
      fromDate: '1900-01-01',
      toDate: '9999-12-31',
      ...params,
    },
  })
  return data
}

export async function listProjectDrilldownJobs(projectId, params = {}) {
  const { data } = await api.get('/jobs/', {
    params: {
      page: 1,
      page_size: 10,
      includeTotal: true,
      archive: false,
      project_id: projectId,
      fromDate: '1900-01-01',
      toDate: '9999-12-31',
      ...params,
    },
  })
  return data
}

export async function createProject(payload) {
  const { data } = await api.post('/projects/', payload)
  return data
}

export async function updateProject(projectId, payload) {
  const { data } = await api.put(`/projects/${projectId}`, payload)
  return data
}

export async function uploadProjectAttachment(projectId, file) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post(`/projects/${projectId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function deleteProjectAttachment(projectId, attachmentId) {
  const { data } = await api.delete(`/projects/${projectId}/attachments/${attachmentId}`)
  return data
}

export async function archiveProject(projectId) {
  const { data } = await api.post(`/projects/${projectId}/archive`)
  return data
}

export async function closeProject(projectId) {
  const { data } = await api.post(`/projects/${projectId}/close`)
  return data
}

export async function openProject(projectId) {
  const { data } = await api.post(`/projects/${projectId}/open`)
  return data
}

export async function cloneProject(projectId, payload) {
  const { data } = await api.post(`/projects/${projectId}/clone`, payload)
  return data
}

export async function listProjectCustomerEndRoles() {
  const { data } = await api.get('/options/project-customer-end-roles')
  return Array.isArray(data) ? data : []
}

export async function listProjectCompanyOptions(params) {
  const { data } = await api.get('/options/companies', { params })
  return normalizeOptionsPayload(data)
}

export async function listProjectBranchOptions(params) {
  const { data } = await api.get('/options/branches', { params })
  return normalizeOptionsPayload(data)
}

export async function listProjectDepartmentOptions(params) {
  const { data } = await api.get('/options/departments', { params })
  return normalizeOptionsPayload(data)
}

export async function listProjectUserOptions(params) {
  const { data } = await api.get('/options/users', { params })
  return normalizeOptionsPayload(data)
}

export async function downloadProjectBulkTemplate(templateType = 'project_billing') {
  const { data } = await api.get('/projects/bulk-upload/template', {
    responseType: 'blob',
    params: { template_type: templateType },
  })
  return data
}

export async function uploadProjectBulkExcel(file) {
  const formData = new FormData()
  formData.append('file', file)
  // Backend now returns HTTP 202 { jobId, status: 'QUEUED' } immediately.
  // Poll GET /api/jobs/{jobId} for progress and the final import report.
  const { data } = await api.post('/projects/bulk-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data  // { jobId, status: 'QUEUED', message }
}


export async function getProjectProfitability(projectId, params = {}) {
  const { data } = await api.get(`/projects/${projectId}/profitability`, { params })
  return data
}

export async function recalculateProjectProfitability(projectId) {
  const { data } = await api.post(`/projects/${projectId}/profitability/recalculate`)
  return data
}

export async function getProjectSubProjects(projectId) {
  const { data } = await api.get(`/projects/${projectId}/sub-projects`)
  return data
}

export async function exportProfitabilityReport({ reportKey, projectIds = [], dateFrom = null, dateTo = null } = {}) {
  const { data } = await api.post(
    '/reports/export',
    {
      module: 'financial',
      reportKey,
      format: 'xls',
      filters: {
        projectIds,
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
        pageSize: 500,
      },
    },
    { responseType: 'blob' },
  )
  return data
}

export async function validateProjectCompletion(projectId) {
  const { data } = await api.get(`/projects/${projectId}/validate-completion`)
  return data
}

export async function getProjectAmcSchedules(projectId) {
  const { data } = await api.get(`/projects/${projectId}/amc-schedules`)
  return data
}

export async function receiveAmcCyclePayment(scheduleId, payload) {
  const { data } = await api.post(`/projects/amc-schedules/${scheduleId}/receive-payment`, payload)
  return data
}

